import { IonButton, IonCol, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonPopover, IonRow, IonToggle, IonToolbar } from "@ionic/react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Avatar_21, headerlogo } from "../Entryfile/imagepath";
import '../theme/style2.css';
import keycloak from '../lib/keycloak';
import { notificationsOutline, personCircleOutline } from "ionicons/icons";
import Sidebar from "./Sidebar";

const Head: React.FC = (props) => {
    // const pro = useState(props)
    const location = useLocation();
    const history = useHistory();

    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [modalopen, setModalopen] = useState(false);

    const [show, setShow] = useState(false);
    const [mobileshow, setMobileshow] = useState(false);

    const [show1, setShow1] = useState(false);

    const [name] = useState(localStorage.getItem("EmpName"));

    const log = () => {
        setShow(!show);
    }

    const mobilelog = () => {
        setMobileshow(!mobileshow);
    }

    const handlesidebar = () => {
        document.body.classList.toggle('mini-sidebar');
    }

    const onMenuClik = () => {
        document.body.classList.toggle('slide-nav');

        // console.log('dddd')
        // setShow1(!show1);
    }

    const openPopover = (e: any) => {
        console.log('dooo');
        popover.current!.event = e;
        setPopoverOpen(true);
    };


    const logout = async () => {
  setModalopen(false);

  const loginType = localStorage.getItem("loginType");

  if (loginType === "keycloak") {
    try {
        
         window.location.href = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
   
    } catch (error) {
      console.error("Keycloak logout failed:", error);

      localStorage.clear();
      sessionStorage.clear();

      window.location.href =
        process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
    }
  } else {
    localStorage.clear();
    sessionStorage.clear();

    window.location.href = "/login";
  }
};

    const open = () => {
        window.location.hash = "/ChangePassword";
    }
    // -------------web view profile dropdown-----------
    const handleOutsideClick = (e: any) => {
        const dropdownMenu = document.querySelector(".user-menu");
        const mobileDropdownMenu = document.querySelector(".mobile-user-menu");
        const mobileSideMenu = document.querySelector("#mobile_btn");

        if (
            dropdownMenu &&
            !dropdownMenu.contains(e.target) &&
            !mobileDropdownMenu?.contains(e.target) &&
            !mobileSideMenu?.contains(e.target)
        ) {
            setShow(false);
            setMobileshow(false);
            setShow1(false);
            document.body.classList.remove("slide-nav");
        }
    };
    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    const cancel = () => {
        setShow(false);
        setMobileshow(false);
        setModalopen(false)
    }

    let pathname = location.pathname
    return (
        <div style={{ minHeight: "60px" }}>
            <div className="header" style={{ right: "0px" }}>
                {/* <div className="header-left">
                    <Link to="/" className="logo">
                        <img src={headerlogo} width={40} height={40} alt="" />
                    </Link>
                </div> */}
                <a id="toggle_btn" style={{ display: pathname.includes('tasks') ? "none" : pathname.includes('compose') ? "none" : "" }} onClick={handlesidebar}>
                    <span className="bar-icon"><span />
                        <span />
                        <span />
                    </span>
                </a>
                <div className="page-title-box">
                    <h3>InfoCareer Pvt Ltd</h3>
                </div>
                <a id="mobile_btn" className="mobile_btn" onClick={() => onMenuClik()}><i className="fa fa-bars" /></a>
                <ul className="nav user-menu">
                    <li className="nav-item dropdown has-arrow main-drop" >
                        <a onClick={() => log()} className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                            <span className="user-img me-1"><img src={Avatar_21} alt="" />
                                <span className="status online" /></span>
                            <span>{name}</span>
                        </a>
                        {
                            show &&
                            <div className="dropdown-menu show" style={{ padding: "10px" }}>
                                <Link className="dropdown-item" to="/ChangePassword" style={{ fontSize: "16px" }}>Change Password</Link>
                                <Link className="dropdown-item" to="#" style={{ fontSize: "16px" }} onClick={() => setModalopen(true)} >Logout</Link>
                            </div>
                        }
                    </li>
                </ul>
                <div className="dropdown mobile-user-menu" style={{ minWidth: "250px" }}>
                    <a onClick={() => mobilelog()} className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fa fa-ellipsis-v" /></a>
                    {
                        mobileshow &&
                        <div className="dropdown-menu  show dropdown" >
                            <Link className="dropdown-item" to="/ChangePassword" >Change Password</Link>
                            <span className="dropdown-item" onClick={() => setModalopen(true)}>Logout</span>
                        </div>
                    }
                </div>
                {/* <div className="bell-icon">
                    <IonIcon color='light' size="large" style={{ cursor: "pointer" }} src={notificationsOutline} />
                    <IonIcon color='light' style={{ cursor: "pointer" }} size="large" src={personCircleOutline} onClick={openPopover} />
                    <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
                        <IonContent>
                            <div onClickCapture={() => setPopoverOpen(false)}>
                                <IonItem style={{ cursor: 'pointer' }}
                                    onClick={() => open()}>
                                    Change Password</IonItem>
                            </div>
                            <div onClickCapture={() => setPopoverOpen(false)}>
                                <IonItem style={{ cursor: 'pointer' }}
                                    onClick={(e) => setModalopen(true)}>
                                    Log Out</IonItem>
                            </div>
                        </IonContent>
                    </IonPopover>
                </div> */}
            </div>
            <Modal
                id="logouts-modal"
                show={modalopen}
                className="modal_logout modal-dialog-centered">
                <Modal.Body>
                    <IonRow>
                        <IonCol style={{ textAlign: "center" }}>
                            <h5>Do you want to logout ?</h5>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="6" style={{ textAlign: "end" }}>
                            <IonButton color="fill" className="btn_logout" onClick={logout}>Yes</IonButton>
                        </IonCol>
                        <IonCol size="6">
                            <IonButton color="fill" className="btn_logout" onClick={(e) => cancel()}>No</IonButton>
                        </IonCol>
                    </IonRow>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Head;